import { Link } from "react-router-dom";
import bannerImg from '../assets/freepik__upload__10247.png'

export default function HeroSection() {
    return (
      <section className="relative h-[900px] flex items-center justify-center">
        {/* Background with gradient overlay */}
        <div className="absolute inset-0">
          <img 
            src={bannerImg}
            alt="Printing press"
            className="w-full h-full object-cover"
          />
          {/* Semi-transparent overlay */}
          <div className="absolute inset-0 bg-gradient-to-r from-secondary-dark to-secondary-dark opacity-60"></div>
        </div>
  
        {/* Content container */}
        <div className="relative z-10 text-center text-white px-4 max-w-6xl mx-auto">
          <div className="space-y-8" data-aos="fade-up">
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-heading font-bold leading-tight">
              <span className="block mb-4">WELCOME TO OUR</span>
              <span className="block text-accent-base">QUALITY OFFSET PRINTING</span>
              <span className="block">DIGITAL PRINTING SERVICES</span>
            </h1>
  
            <p className="text-lg md:text-xl max-w-3xl mx-auto font-body leading-relaxed">
            Capital Offset is a trusted leader in the printing industry, specializing in premium communication materials. We deliver high-quality printing solutions. Our focus on precision and excellence ensures every project exceeds expectations.
            </p>
            <div className="mt-12">
              <Link to="/services">
                <button className="bg-white text-primary-dark px-8 py-4 rounded-full font-semibold text-lg
                hover:bg-white hover:scale-105 transition-all duration-300 shadow-lg
                hover:shadow-xl">
                  VIEW SERVICES
                </button>
              </Link>
            </div>
          </div>
        </div>
  
        {/* Animated scroller indicator */}
        <div className="absolute bottom-8 left-1/2 -translate-x-1/2 animate-bounce">
          <svg className="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 14l-7 7m0 0l-7-7m7 7V3" />
          </svg>
        </div>
      </section>
    );
}
